const firebaseConfig = {
    apiKey: "AIzaSyAaxahQWDQwBTzzzt27XtfP-Ad737xcLT0",
    authDomain: "engichat.firebaseapp.com",
    projectId: "engichat",
    storageBucket: "engichat.appspot.com",
    messagingSenderId: "107323127620",
    appId: "1:107323127620:web:3881e7bfa22e23a2b6c911",
    databaseURL: "https://engichat-default-rtdb.firebaseio.com/"
};

export default firebaseConfig;